module.exports = __webpack_public_path__ + "img/poster3.a2674bbf.jpg";